import { Popover } from '@headlessui/react';
import { CheckCircleIcon, XIcon } from '@heroicons/react/solid';
import { format } from 'date-fns';
import { useUser } from '@auth0/nextjs-auth0';
import { useRouter } from 'next/router';

const TimeSlot = ({
  timeslot,
  timeslotIdx,
  setTriggerBookAction,
  axiosService,
  isLast,
  companyId,
  setLoading,
}) => {

  const {user} = useUser()
  const router = useRouter();

  async function handleBookAction(timeslot, close, companyId) {
    setLoading(true);
    try {
      await axiosService.post(`reservations/${companyId}/engine`, {
        timeslotId: timeslot.id,
      });
      setTriggerBookAction(true);
      close();
      setTriggerBookAction(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function handleCancelBookAction(timeslot, close) {
    setLoading(true);
    try {
      await axiosService.delete(
        `reservations/${companyId}/cancel/${timeslot.id}/engine`
      );
      setTriggerBookAction(true);
      close();
      setTriggerBookAction(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <tr
      id={timeslot.id}
      key={timeslot.id}
      className={
        timeslot?.validations?.IS_ALREADY_BOOKED_BY_USER
          ? 'bg-green-50'
          : timeslotIdx % 2 === 0
          ? 'bg-white'
          : 'bg-gray-50'
      }
    >
      <td className="px-4 py-3 text-sm font-medium text-gray-500 hidden sm:table-cell">
        <>
          {timeslot?.validations?.IS_ALREADY_BOOKED_BY_USER ? (
            <div className="flex -ml-1">
              <div className="flex-shrink-0">
                <CheckCircleIcon
                  className="h-5 w-5 text-green-400"
                  aria-hidden="true"
                />
              </div>
              {/* <span className="text-sm text-green-500">Booked</span> */}
            </div>
          ) : (
            <span>{timeslotIdx + 1}.</span>
          )}
        </>
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium">
        <div className="block sm:hidden mb-2">
          <div>
            <span className="pr-3 text-left text-xs font-medium text-gray-500 uppercase w-12 inline-block py-0.5">
              Date
            </span>
            {format(new Date(timeslot?.startsAt), 'HH:mm')}-
            {format(new Date(timeslot?.endsAt), 'HH:mm | EEE dd LLL')}
          </div>
          <div className="space-x-2">
              <span>{timeslot.sessionType?.name}</span>
              <span>{timeslot.info}</span>
          </div>
          <div>
            <span className="pr-3 text-left text-xs font-medium text-gray-500 uppercase w-12 inline-block py-0.5">
              Slots
            </span>
            {/* {timeslot._count.reservations}/{timeslot.maxCapacity} */}
            {timeslot.maxCapacity}
          </div>
        </div>
        {/* <div>
          {timeslot?.validations?.IS_PAST_DATE ||
          !timeslot?.validations?.IS_WEEK_ENABLED ? (
            timeslot?.validations?.IS_ALREADY_BOOKED_BY_USER ? (
              <button
                disabled
                type="button"
                className="w-24 sm:w-auto inline-flex items-center justify-center px-2.5 py-2.5 sm:py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white opacity-50 focus:ring-indigo-500"
              >
                Cancel
              </button>
            ) : (
              <button
                disabled
                type="button"
                className="w-24 sm:w-auto inline-flex items-center justify-center px-2.5 py-2.5 sm:py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white opacity-50 focus:ring-indigo-500"
              >
                Book
              </button>
            )
          ) : timeslot?.validations?.IS_ALREADY_BOOKED_BY_USER ? (
            <Popover className="relative">
              {({ close }) => (
                <>
                  <Popover.Button className="w-24 sm:w-auto inline-flex items-center justify-center px-2.5 py-2.5 sm:py-1.5 border border-transparent text-sm font-medium rounded shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                    Cancel
                  </Popover.Button>
                  <Popover.Panel
                    className={`bg-white absolute z-10 w-72 sm:w-screen sm:max-w-xs sm:px-0 left-0 ${
                      isLast ? 'bottom-0' : 'top-0'
                    }`}
                  >
                    <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                      <div className="p-4">
                        <div className="flex items-start">
                          <div className="ml-3 w-0 flex-1 text-left">
                            <p className="text-sm font-medium text-gray-900">
                              Cancel reservation
                            </p>
                            <p className="mt-1 text-sm text-gray-500">
                              You are going to release that slot!
                            </p>
                            <div className="mt-4 flex">
                              <button
                                onClick={() =>
                                  handleCancelBookAction(timeslot, close)
                                }
                                type="button"
                                className="w-24 sm:w-auto inline-flex items-center justify-center px-2.5 py-2.5 sm:py-1.5 border border-red-300 shadow-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                          <div className="ml-4 flex-shrink-0 flex">
                            <button
                              className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              onClick={() => close()}
                            >
                              <span className="sr-only">Close</span>
                              <XIcon className="h-5 w-5" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Popover.Panel>
                </>
              )}
            </Popover>
          ) : (
            <>
            { user?.email ? <Popover className="relative">
                {({ close }) => (
                  <>
                    <Popover.Button className="w-24 sm:w-auto inline-flex items-center justify-center px-2.5 py-2.5 sm:py-1.5 border border-transparent text-sm font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                      Book
                    </Popover.Button>
                    <Popover.Panel
                      className={`bg-white absolute z-10 w-72 sm:w-screen sm:max-w-xs sm:px-0 left-0 ${
                        isLast ? 'bottom-0' : 'top-0'
                      }`}
                    >
                      <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="p-4">
                          <div className="flex items-start">
                            <div className="ml-3 w-0 flex-1 text-left">
                              <p className="text-sm font-medium text-gray-900 ">
                                Book slot
                              </p>
                              <p className="mt-1 text-sm text-gray-500">
                                You are going to book that slot!
                              </p>
                              <div className="mt-4 flex">
                                <button
                                  onClick={() =>
                                    handleBookAction(timeslot, close, companyId)
                                  }
                                  type="button"
                                  className="w-24 sm:w-auto inline-flex items-center justify-center px-2.5 py-2.5 sm:py-1.5 border border-transparent text-sm font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Book
                                </button>
                              </div>
                            </div>
                            <div className="ml-4 flex-shrink-0 flex">
                              <button
                                className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                onClick={() => close()}
                              >
                                <span className="sr-only">Close</span>
                                <XIcon className="h-5 w-5" aria-hidden="true" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Popover.Panel>
                  </>
                )}
              </Popover> : <button
                                  onClick={() =>
                                    router.push('/api/auth/login')
                                  }
                                  type="button"
                                  className="w-24 sm:w-auto inline-flex items-center justify-center px-2.5 py-2.5 sm:py-1.5 border border-transparent text-sm font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Book
                                </button>}
            </>
          )}
        </div> */}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 hidden sm:table-cell">
        {format(new Date(timeslot?.startsAt), 'HH:mm')}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 hidden sm:table-cell">
        {format(new Date(timeslot?.endsAt), 'HH:mm')}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 hidden sm:table-cell">
        {/* {timeslot._count.reservations}/{timeslot.maxCapacity} */}
        {timeslot.maxCapacity}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 hidden sm:table-cell">
        {timeslot.sessionType?.name}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 hidden sm:table-cell">
        {timeslot.info}
      </td>
    </tr>
  );
};

export { TimeSlot };
